import { Nodo } from '../nodo/nodo';
import { Alarma } from '../alarmas/alarma';
import {RegAlarma} from "../regAlarma/regAlarma";
export class Sensor{
	_id: string;
	etiqueta: string;
	posicionString: Number;
	numeroMediciones:Number;
	unidadMedidaVisual: string;
	estado: boolean;
	tipo_id:  any;
	lastMediciones: [Number];
	nodo_id: any;
	alarmaActiva: boolean;
	alarmas: Alarma[];
	sucursal_id: string;
	color: string;
	regAlarmas: RegAlarma[];
	alarmaSensorNull: boolean;
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./app/sensor/sensor.ts